import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  LeaveRequest,
  LeaveRequestFilterParams,
} from "../../types/leaveRequestType";
import leaveRequestApis from "../../api/leaveRequestApis";

interface LeaveRequestState {
  data: LeaveRequest[];
  loading: boolean;
  page: number;
  size: number;
  totalElements: number;
  filters: LeaveRequestFilterParams;
}

const initialState: LeaveRequestState = {
  data: [],
  loading: false,
  page: 0,
  size: 10,
  totalElements: 0,
  filters: {
    branchCode: "",
  },
};

export const fetchLeaveRequests = createAsyncThunk(
  "leaveRequests/fetch",
  async (params: LeaveRequestFilterParams) => {
    const response = await leaveRequestApis.getLeaveRequests(params);
    return response?.data;
  },
);

export const updateLeaveStatus = createAsyncThunk(
  "leaveRequests/updateStatus",
  async (
    {
      leaveRequestId,
      status,
    }: { leaveRequestId: number; status: "APPROVED" | "REJECTED" },
    { rejectWithValue },
  ) => {
    try {
      const response = await leaveRequestApis.updateLeaveStatus(
        leaveRequestId,
        status,
      );
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

const leaveRequestSlice = createSlice({
  name: "leaveRequests",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    setPage(state, action) {
      state.page = action.payload;
    },
    resetLeaveRequests(state) {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeaveRequests.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLeaveRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.content || [];
        state.totalElements = action.payload?.totalElements || 0;
      })
      .addCase(fetchLeaveRequests.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateLeaveStatus.fulfilled, (state, action) => {
        const updated = action.payload;
        if (!updated) return;

        const index = state.data.findIndex(
          (l) => l.leaveRequestId === updated.leaveRequestId,
        );

        if (index !== -1) {
          state.data[index].status = updated.status;
        }
      });
  },
});

export const { setFilters, setPage, resetLeaveRequests } =
  leaveRequestSlice.actions;

export default leaveRequestSlice.reducer;
